import {SwiperHorizontal} from '@molecules';
import styled from 'styled-components';

export const StyledSwiperHorizontal = styled(SwiperHorizontal)`
  &.swiper {
    height: 100%;
    & > div.swiper-wrapper {
      padding: 0;
    }

    .swiper-slide {
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
    }
  }
`;
